// export const OptionRowPage = [1, 2, 3, 4]
export const OptionRowPage = [10, 20, 30, 40]
export const timeDebounceSearch = 1500
